import * as React from 'react';
import { connect } from 'react-redux';
import { hideMobileProfile } from '../../actions/profileActions';
import { showComingSoon } from '../../actions/modalActions';
import {
    DASHBOARD, POLICY_DETAILS, CLAIMS_HISTORY, SUBMIT_CLAIM, CLAIM_HISTORY, CLAIM_HISTORY_V2,
} from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { Accordion, Card, Image } from 'react-bootstrap';
import './Claims.css'
import { navigateTo } from '../../actions/navigationActions';

class Claims extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            eventKey1Open: false,
            eventKey2Open: false,
            eventKey3Open: false,
            eventKey4Open: false,
            eventKey5Open: false,
            eventKey6Open: false,
            eventKey7Open: false,
            eventKey8Open: false,
            eventKey9Open: false,
        }
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
        this.handleShowComingSoon = this.handleShowComingSoon.bind(this);
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
    }

   async handleRedirect(destination) {
        if (destination === CLAIMS_HISTORY && this.props.ssp.useClaimHistoryV2) {
            if (this.props.profile.personalClaims === undefined || this.props.profile.personalClaims === "" || this.props.profile.personalClaims.length === 0) {
               await this.props.dispatchHandleSetLoadingAndEmpty(false, true);
            }
            this.props.redirectTo(CLAIM_HISTORY_V2);
        }
        else {
            this.props.redirectTo(destination);
        }
    }

    handleCoverRedirect() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            this.props.redirectTo(POLICY_DETAILS);
        }
    }

    handleAccordianArrow(e: any) {

        switch (e) {
            case 1:
                this.setState({ eventKey1Open: !this.state.eventKey1Open })
                this.setState({ eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 2:
                this.setState({ eventKey2Open: !this.state.eventKey2Open })
                this.setState({ eventKey1Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 3:
                this.setState({ eventKey3Open: !this.state.eventKey3Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 4:
                this.setState({ eventKey4Open: !this.state.eventKey4Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 5:
                this.setState({ eventKey5Open: !this.state.eventKey5Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 6:
                this.setState({ eventKey6Open: !this.state.eventKey6Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 7:
                this.setState({ eventKey7Open: !this.state.eventKey7Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 8:
                this.setState({ eventKey8Open: !this.state.eventKey8Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey9Open: false })
                break;
            case 9:
                this.setState({ eventKey9Open: !this.state.eventKey9Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false })
                break;
            default:
        }
    }

    async handleShowComingSoon() {
        this.props.dispatchShowComingSoon();
    }

    public render() {
        const { profile } = this.props;
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]

        //let covers = <div></div>;
        //if (this.props.profile.selectedPersonalPolicy !== undefined) {
        //    covers = this.props.profile.selectedPersonalPolicy.covers.map((cover) => {
        //        if (cover.isMainline === true) {
        //            return <div key={cover.id} onClick={this.handleCoverRedirect}>
        //                <ClaimsCard id={cover.id} alertCount="0"
        //                    headerText={cover.productName}
        //                    bodyText={cover.riskItems[0].description}
        //                    premium={cover.riskItems[0].premium}
        //                    type={cover.riskItems[0].type}
        //                    image={cover.image}
        //                />
        //            </div>
        //        }
        //    });
        //}
        return (
            <div id="Claims" className="container-fluid">
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Claims" />
                {profile.selectedPersonalPolicy !== undefined &&
                    <>
                        <div className="row">
                            <div className="col-12">
                                <div className="claims-block">
                                    <h3>Claims</h3>
                                    <p>Manage your claims in just a few clicks</p>
                                </div>
                            </div>

                        <div className="col-12">
                            <div className="row submit-a-claim-history-row">
                                <div className="col-12 col-lg-6 px-lg-3 submit-a-claim-history-col-1">
                                    <div className="submit-a-claim-history-holder">
                                        <table className="submit-a-claim-history-table">
                                            <tbody>
                                                <tr>
                                                    <td className="submit-a-claim-history-table-td-top">
                                                        <h3>Submit a claim</h3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="submit-a-claim-history-table-td-middle">
                                                        <p>Need to claim? Click below:</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="submit-a-claim-history-table-td-bottom">
                                                        <button className="btn btn-solid-red submit-claim-button" onClick={() => this.handleRedirect(SUBMIT_CLAIM)}>Submit a claim</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 px-lg-3 submit-a-claim-history-col-2">
                                    <div id="ClaimHistory" className="submit-a-claim-history-holder">
                                        <table className="submit-a-claim-history-table">
                                            <tbody>
                                                <tr>
                                                    <td className="submit-a-claim-history-table-td-top">
                                                        <h3>Claims history</h3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="submit-a-claim-history-table-td-middle">
                                                        <p>Check out all the claims you've submitted here:</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="submit-a-claim-history-table-td-bottom">
                                                        <button id="ViewClaims" className="btn btn-outline-red claims-history-button" onClick={() => this.handleRedirect(CLAIMS_HISTORY)}>See details</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-6  px-lg-3 mb-3 claims-what-to-do-col">
                            <div className="claims-what-to-do-holder">
                                <h3>What to do in the event of a claim</h3>
                                <div className="claims-what-to-do-accordion-holder">
                                    <Accordion>
                                        <Card>
                                            <Accordion.Toggle as={Card.Header} eventKey="1" id="Accordian1" onClick={() => this.handleAccordianArrow(1)}>
                                                <span className="claims-card-label">Step 1: Tell us</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey1Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="1">
                                                <Card.Body>
                                                    <p>
                                                        The sooner you notify us, the quicker we can help you. Please take note of these
                                                        important time limits:
                                                    </p>
                                                    <ul>
                                                        <li>Report your claim or any incident that may lead to a claim to us as soon as possible, but no later than 30 days, after any incident.</li>
                                                        <li>This includes incidents for which you do not want to claim right away, but which may result in a claim in the future.</li>
                                                        <li>Give us all documentation relating to your claim as soon as possible. You can drop us an email at {this.props.ssp.claims_email}</li>
                                                    </ul>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className="mb-3 mb-lg-3">
                                            <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => this.handleAccordianArrow(2)}>
                                                <span className="claims-card-label">Step 2: Tell the police</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey2Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="2">
                                                <Card.Body>
                                                    <ul>
                                                        <li>If you have been involved in a car accident, you must report it to the police within 24 hours, even if there is no damage to your car or motorbike.</li>
                                                        <li>If you have suffered a theft, hi-jacking, burglary or any crime related event, you must tell the police immediately after becoming aware of the incident.</li>
                                                    </ul>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className="mb-3 mb-lg-3">
                                            <Accordion.Toggle as={Card.Header} eventKey="3" onClick={() => this.handleAccordianArrow(3)}>
                                                <span className="claims-card-label">Step 3: Do the paperwork</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey3Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="3">
                                                <Card.Body>
                                                    <p>We need a copy of:</p>
                                                    <ul>
                                                        <li>The police report.</li>
                                                        <li>The police case number.</li>
                                                        <li>Your statement to the police.</li>
                                                        <li>Details of the police station and attending officer.</li>
                                                        <li>A detailed list of all items lost, stolen or damaged.</li>
                                                        <li>Any other relevant documentation.</li>
                                                        <li>Details of any third party involved in the incident, if applicable.</li>
                                                    </ul>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className="mb-3 mb-lg-3">
                                            <Accordion.Toggle as={Card.Header} eventKey="4" onClick={() => this.handleAccordianArrow(4)}>
                                                <span className="claims-card-label">Step 4: Check and let us know</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey4Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="4">
                                                <Card.Body>
                                                    <p>We need to know if there’s any other insurance policy that covers the same
                                                    incident.</p>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className="mb-3 mb-lg-3">
                                            <Accordion.Toggle as={Card.Header} eventKey="5" onClick={() => this.handleAccordianArrow(5)}>
                                                <span className="claims-card-label">Step 5: Keep us updated</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey5Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="5">
                                                <Card.Body>
                                                    <p>Please tell us immediately if:</p>
                                                    <ul>
                                                        <li>You become aware of any possible prosecution, legal proceedings or claim
                                                        that could be lodged against you as a result of the incident.</li>
                                                        <li>Any other relevant or new information comes to light regarding the
                                                        incident that you claimed for, even if this information only surfaces after
                                                        you’ve submitted the claim, or if the claim’s already been finalised.</li>
                                                    </ul>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className="mb-3 mb-lg-3">
                                            <Accordion.Toggle as={Card.Header} eventKey="6" onClick={() => this.handleAccordianArrow(6)}>
                                                <span className="claims-card-label">Step 6: Wait for us to help you</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey6Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="6">
                                                <Card.Body>
                                                    <p>Never permit any replacement or repairs that we haven’t authorised yet. Get
                                                    our written approval first before disposing of any damaged property, or
                                                    repairing or replacing any losses you may have suffered. Failure to do so
                                                    may lead to your claim being rejected.</p>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className="mb-3 mb-lg-3">
                                            <Accordion.Toggle as={Card.Header} eventKey="7" onClick={() => this.handleAccordianArrow(7)}>
                                                <span className="claims-card-label">Step 7: Help us help you</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey7Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="7" onClick={() => this.handleAccordianArrow(1)}>
                                                <Card.Body>
                                                    <p>You need to act on, or take note of, the following:</p>
                                                    <ul>
                                                        <li>Pay your excess, plus any additional excess amounts (if applicable) stated on your policy schedule.</li>
                                                        <li>The excess amount that you have to pay will consist of:
                                                        <ul>
                                                                <li>The basic excess amount that applies to each specific insured incident/item.</li>
                                                                <li>Plus any additional excess amounts that may be applicable for some of the
                                                                insured incidents or circumstances, the details for both of which are noted on your
                                                                policy schedule.</li>
                                                            </ul>
                                                        </li>
                                                        <li>Excess amounts are payable even if you didn’t cause the incident.</li>
                                                        <li>Assist us, where possible, in recovering losses from the third parties responsible for the loss or damage. We’ll reimburse you for any reasonable extra expenses you incur for this purpose.</li>
                                                        <li>Comply with our instructions and requests as and when we need your assistance.</li>
                                                    </ul>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className="mb-3 mb-lg-3">
                                            <Accordion.Toggle as={Card.Header} eventKey="8" onClick={() => this.handleAccordianArrow(8)}>
                                                <span className="claims-card-label">Step 8: Get it done</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey8Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="8">
                                                <Card.Body>
                                                    <p>Any repairs or replacements must be completed within 3 months of your claim
                                                    being settled.</p>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className="mb-3 mb-lg-3">
                                            <Accordion.Toggle as={Card.Header} eventKey="9" onClick={() => this.handleAccordianArrow(9)}>
                                                <span className="claims-card-label">Step 9: Let us take care of the difficult part</span>
                                                <div className={"accordion-arrow-svg" + (this.state.eventKey9Open ? ' isRotatednew' : '')}></div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="9">
                                                <Card.Body>
                                                    <p>Never admit guilt or offer a settlement to any other party involved in an
                                                    incident in which you are involved. We won’t be bound by any such admission
                                                    or offer that you make.</p>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6  px-lg-3 mb-3 claims-need-help-col">
                            <div className="claims-need-help-holder">
                                <h3>Need help</h3>
                                <p className="Speak">Speak to 1 of our claims consultants</p>

                                <div className="contact-holder">
                                    <span className="claims-label">Email</span>
                                    <span className="claims-anchor">
                                        <a href={"mailto:" + this.props.ssp.claims_email} target="_blank">{this.props.ssp.claims_email}</a>
                                    </span>
                                    <div className="claims-contact-row"></div>
                                    <span className="claims-label"> Phone no. </span>
                                    <span className="claims-anchor">
                                        <a href={"tel:" + this.props.ssp.contactUs_tel} target="_blank">{this.props.ssp.contactUs_tel}</a>
                                    </span>
                                </div>
                               
                                <div className="Chat-rectangle invisible">
                                    <div className="container pt-3">
                                        <div className="row">
                                            <div className="col-lg-2 col-4">
                                                <Image src="./images/icon-avatar-01.png" className="img-fluid chat-icon" />
                                            </div>
                                            <div className="col-lg-10 col-8">
                                                <p className="contact mb-1">Speak to a claims consultant</p>
                                                <p className="Speak chat">Start chatting now</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchShowComingSoon: () => dispatch(showComingSoon()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Claims);